import React, { useState, useEffect, useContext, useRef } from "react";
import {
  ProgramContainer,
  Body,
  Avatar,
  BookingHeading,
  NoprogramContainer,
  RequestsKeyHeaders,
  TableContainerOuter,
  AvatarInfo,
  MeetingsHead,
  FilterOption,
  FilterText,
  SearchBoxFilterContainer,
  DropIcon,
  DropdownItems,
  DropdownButton,
  RequestedByContainer,
  FilterOptions,
  FilterHeadText,
  FilterBy,
  FilterLabel,
  FilterLabelText,
  FilterClear,
  FilterButtons,
  ResetButton,
  ApplyButton,
  DateInputs,
  SearchParticipantsWrapper,
  TableContainer,
  Purpose,
  ExportDeleteBtnContainer,
  MeetingsInfo,
  BackButton,
  ButtonText,
} from "./styles";
import callAPI from "../../../../api/apiCaller";
import { Context } from "../../../../Store";
import Button from "../../../../common/Button";
import { Link, useNavigate } from "react-router-dom";
import Loading from "../../../../common/Loading";
import { ButtonSpacer, SectionActions } from "../../../../common/Button/styles";
import Labelize from "../../../../common/Labelize";
import {
  NumberOfDaysBetweenDates,
  NumberOfDaysBetweenDatesAndCurrentDate,
  dateToUnixTimeStamp,
  formatDateForMeetings,
} from "../../../../common/utils";
import PaginatedTable from "../../../../common/Table/PaginatedTable";
import { TableActions } from "../../../../common/Table/styles";
import { Info } from "../../Programs/ProgramContent/ProgramParticipants/ActiveParticipants/styles";
import { useParams } from "react-router-dom";
import Modal from "../../../../common/Modal";
import MeetingInfo from "../../Programs/popups/MeetingInfo";
import Icon from "../../../../common/Icon";
import TextInput from "../../../../common/TextInput";
import Checkbox from "../../../../common/Checkbox";
import EnhancedDateRangePicker from "../../../../common/DatePicker";
import { ExportCSV } from "../../../../common/utils";

function ActivityContent({
  currentPage,
  searchParticipant,
  setSearchParticipant,
  exportData,
  setExportData,
  setExportCurrentPageData,
}) {
  const params = useParams();
  const [requests, setRequests] = useState(null);
  const { dispatch, state } = useContext(Context);
  const navigate = useNavigate();
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [isDeleteRequest, setIsDeleteRequest] = useState(false);
  const [isViewMore, setIsviewMore] = useState(false);
  const [program, setProgram] = useState(false);
  const [actionButtons, setActionButtons] = useState(null);
  const [filterOptions, setFilterOptions] = useState(false);
  const [filteredRequests, setFilteredRequests] = useState([]);
  const [requestedBy, setRequestedBy] = useState("");
  const [acceptedBy, setAcceptedBy] = useState("");
  const [dateRange, setDateRange] = useState({ from: null, to: null });
  const [loader, setLoader] = useState(false);

  let url =
    window.location.protocol +
    "//" +
    window.location.host +
    "/programs/" +
    program?.id +
    "/home";

  /**********/
  const [checkboxStates, setCheckboxStates] = useState({});

  // console.log("checkboxStates:", checkboxStates);

  const allChecked =
    Object.keys(checkboxStates).length > 0 &&
    Object.keys(checkboxStates).length === filteredRequests?.length;
  Object.keys(checkboxStates)?.map((ele) => {
    return checkboxStates[ele]?.checked;
  });

  const selectAllHandler = (value) => {
    if (allChecked) {
      setCheckboxStates({});
    } else {
      setCheckboxStates(
        filteredRequests?.reduce((acc, mentor) => {
          const isChecked = !mentor[mentor?.id]?.checked;

          acc[mentor.id] = { checked: isChecked, data: mentor };
          return acc;
        }, {})
      );
    }
  };

  const clearSelectedHandler = () => {
    setCheckboxStates({});
  };

  const handleCheckboxChange = (rowId, data) => {
    setCheckboxStates((prevState) => {
      const isChecked = !prevState[rowId]?.checked;

      const updatedState = {
        ...prevState,
        [rowId]: { checked: isChecked, data },
      };

      // Keep only entries where `checked` is true
      const filteredState = Object.fromEntries(
        Object.entries(updatedState).filter(
          ([_, value]) => value.checked === true
        )
      );

      return filteredState;
    });
  };

  const labels = [
    "Requested By",
    "Purpose",
    "Days Pending",
    currentPage === "UPCOMING" || currentPage === "COMPLETE"
      ? "Date"
      : "Requested On",
    "Accepted By",
  ];

  const dataKeys = [
    "requestedBy",
    "purpose",
    "daysPending",
    currentPage === "UPCOMING" || currentPage === "COMPLETE"
      ? "date"
      : "requestedOn",
    "acceptedBy",
  ];

  const exportDataHandler = () => {
    const tableData = Object.keys(checkboxStates)
      ?.map((id) => {
        const data = checkboxStates[id]?.data;

        if (!data) return null;

        const days = data?.meetingScheduleDate
          ? NumberOfDaysBetweenDates([
              data?.acceptedOn,
              dateToUnixTimeStamp(data?.createdAt),
            ])
          : NumberOfDaysBetweenDatesAndCurrentDate([
              dateToUnixTimeStamp(data?.createdAt),
            ]);

        return {
          requestedBy: data?.user?.firstName + " " + data?.user?.lastName,
          purpose: data?.reasonForMeeting,
          daysPending: days >= 0 ? days : "-",
          [currentPage === "UPCOMING" || currentPage === "COMPLETE"
            ? "date"
            : "requestedOn"]: formatDateForMeetings(data.createdAt),
          acceptedBy:
            data?.Mentor?.firstName && data?.Mentor?.lastName
              ? data?.Mentor?.firstName + " " + data?.Mentor?.lastName
              : "-",
        };
      })
      .filter(Boolean);

    ExportCSV({
      labels,
      dataKeys,
      tableData: tableData,
      fileName: "Export_MEETINGS",
    });
  };

  // const deleteMultipleDataHandler = () => {
  //   const dataIds = Object.keys(checkboxStates);

  //   const participantIds = dataIds?.map((id) => {
  //     return checkboxStates[id]?.data?.id;
  //   });

  //   callAPI(dispatch, "deleteMultipleMeetings", {
  //     tid: +params.selectedProgram,
  //     data: [...participantIds],
  //   }).then(() => {
  //     // getMentorParticipantOpenNetworking();
  //     getMeetingsHandler();
  //   });
  // };

  const printDataHandler = () => {
    const selectedData = Object.keys(checkboxStates)
      ?.map((id) => {
        const data = checkboxStates[id]?.data;
        if (!data) return null;

        const days = data?.meetingScheduleDate
          ? NumberOfDaysBetweenDates([
              data?.acceptedOn,
              dateToUnixTimeStamp(data?.createdAt),
            ])
          : NumberOfDaysBetweenDatesAndCurrentDate([
              dateToUnixTimeStamp(data?.createdAt),
            ]);

        return {
          requestedBy: data?.user?.firstName + " " + data?.user?.lastName,
          purpose: data?.reasonForMeeting,
          daysPending: days >= 0 ? days : "-",
          [currentPage === "UPCOMING" || currentPage === "COMPLETE"
            ? "date"
            : "requestedOn"]: formatDateForMeetings(data.createdAt),
          acceptedBy:
            data?.Mentor?.firstName && data?.Mentor?.lastName
              ? data?.Mentor?.firstName + " " + data?.Mentor?.lastName
              : "-",
        };
      })
      .filter(Boolean);

    if (selectedData.length === 0) {
      alert("No data to print");
      return;
    }

    const tableHtml = `
    <table>
      <thead>
        <tr>
          ${labels.map((key) => `<th>${key}</th>`).join("")}
        </tr>
      </thead>
      <tbody>
        ${selectedData
          .map(
            (row) => `
          <tr>
            ${dataKeys.map((key) => `<td>${row[key] ?? ""}</td>`).join("")}
          </tr>
        `
          )
          .join("")}
      </tbody>
    </table>
  `;

    const printWindow = window.open("", "", "width=900,height=700");

    const htmlContent = `
    <html>
      <head>
        <title>Print</title>
        <style>
          body {
            font-family: Arial, sans-serif;
            padding: 20px;
          }
          table {
            border-collapse: collapse;
            width: 100%;
          }
          th, td {
            border: 1px solid #000;
            padding: 8px;
            text-align: left;
          }
          th {
            background-color: #f0f0f0;
          }
        </style>
      </head>
      <body>
        ${tableHtml}
        <script>
          window.onload = function () {
            window.print();
            window.onafterprint = () => window.close();
          };
        </script>
      </body>
    </html>
  `;

    printWindow.document.write(htmlContent);
    printWindow.document.close();
  };
  /**********/

  const filterRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setFilterOptions(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getMeetingsHandler = () => {
    setLoader(true);

    callAPI(
      dispatch,
      currentPage === "UPCOMING"
        ? "ProgramNewRequestForManager"
        : currentPage === "COMPLETE"
        ? "ProgramCompleteRequestForManager"
        : "ProgramUnFullFiledRequestForManager",
      { id: params.selectedProgram }
    )
      .then((res) => {
        if (res.isResponseOk) {
          setRequests(res?.data?.data);
          setFilteredRequests(res?.data?.data);
          const preparedExportData = res?.data?.data?.map((row) => {
            const days = row?.meetingScheduleDate
              ? NumberOfDaysBetweenDates([
                  row?.acceptedOn,
                  dateToUnixTimeStamp(row?.createdAt),
                ])
              : NumberOfDaysBetweenDatesAndCurrentDate([
                  dateToUnixTimeStamp(row?.createdAt),
                ]);

            return {
              requestedBy: `${row.user.firstName} ${row.user.lastName}`.replace(
                /,/g,
                ""
              ),
              purpose: row.reasonForMeeting?.replace(/,/g, "") || "",
              days: days >= 0 ? days : "-",
              date:
                formatDateForMeetings(row.createdAt)?.replace(/,/g, "") || "",
              acceptedBy: `${row.Mentor?.firstName || ""} ${
                row?.Mentor?.lastName || ""
              }`.replace(/,/g, ""),
            };
          });

          setExportData(preparedExportData);
          // setExportCurrentPageData(preparedExportData);
        } else {
          setRequests([]);
          setFilteredRequests([]);
        }
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const applyFilters = () => {
    const filtered = requests.filter((item) => {
      const matchesRequestedBy =
        requestedBy === "" ||
        item?.user?.firstName
          ?.toLowerCase()
          .includes(requestedBy.toLowerCase()) ||
        item?.user?.lastName?.toLowerCase().includes(requestedBy.toLowerCase());

      const matchesAcceptedBy =
        acceptedBy === "" ||
        item?.Mentor?.firstName
          ?.toLowerCase()
          .includes(acceptedBy.toLowerCase()) ||
        item?.Mentor?.lastName
          ?.toLowerCase()
          .includes(acceptedBy.toLowerCase());

      const matchesDateRange =
        (!dateRange.from && !dateRange.to) ||
        (new Date(item.createdAt).getTime() >=
          new Date(dateRange.from).getTime() &&
          new Date(item.createdAt).getTime() <=
            new Date(dateRange.to).getTime());
      return matchesRequestedBy && matchesAcceptedBy && matchesDateRange;
    });

    setFilteredRequests(filtered);
  };

  useEffect(() => {
    if (currentPage) {
      getMeetingsHandler();
    }
  }, [currentPage]);

  useEffect(() => {
    if (!searchParticipant) {
      setFilteredRequests(requests);
      return;
    }

    const searchTerm = searchParticipant.toLowerCase();

    const filterParticipant = requests?.filter((item) => {
      const firstName = item?.user?.firstName?.toLowerCase() || "";
      const lastName = item?.user?.lastName?.toLowerCase() || "";
      const mentorFirstName = item?.Mentor?.firstName?.toLowerCase() || "";
      const mentorLastName = item?.Mentor?.lastName?.toLowerCase() || "";

      return (
        firstName.startsWith(searchTerm) ||
        lastName.startsWith(searchTerm) ||
        mentorFirstName.startsWith(searchTerm) ||
        mentorLastName.startsWith(searchTerm)
      );
    });

    setFilteredRequests(filterParticipant);
  }, [searchParticipant, requests]);

  function removeItemFromArray(itemToRemove) {
    const updatedArray = requests.filter((item) => item.id !== itemToRemove);
    setRequests(updatedArray);
  }

  function deleteProgram(meeting) {
    setIsDeleteRequest(true);
    callAPI(dispatch, "deleteMeetingRequest", {
      rid: meeting.id,
      id: meeting.id,
      tid: meeting.programId,
    }).then(() => {
      setIsDeleteRequest(false);
      removeItemFromArray(meeting.id);
      setIsDeleteModal(false);
    });
  }

  const programInformation = () => {
    callAPI(dispatch, "getProgramInformation", {
      id: params.selectedProgram,
    }).then((info) => {
      setProgram(info.data);
    });
  };

  React.useEffect(() => {
    programInformation();
  }, []);

  const resetFilters = () => {
    setRequestedBy("");
    setAcceptedBy("");
    setDateRange({ from: null, to: null });
    setFilteredRequests(requests);
  };

  if (requests === null) {
    return (
      <ProgramContainer>
        <Loading loadingItem="Activity Details" />
      </ProgramContainer>
    );
  }

  const closeModal = () => {
    setIsviewMore(false);
  };

  return (
    <ProgramContainer>
      <Body>
        <TableContainerOuter>
          <Labelize label={""}>
            <MeetingsHead>
              {/* <BookingHeading>
                {currentPage === "UPCOMING"
                  ? "New Bookings"
                  : currentPage === "COMPLETE"
                  ? "Completed Bookings"
                  : "Unaccepted Requests"}
              </BookingHeading> */}
              <div
                style={{
                  display: "block",
                }}
              >
                <ExportDeleteBtnContainer
                  style={{
                    display:
                      Object.keys(checkboxStates).length === 0
                        ? "none"
                        : "flex",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "4px",
                    }}
                  >
                    <MeetingsInfo>
                      {Object.keys(checkboxStates).length + " Selected"}
                    </MeetingsInfo>
                    <button
                      onClick={clearSelectedHandler}
                      style={{
                        background: "none",
                        border: "none",
                        fontSize: "12px",
                        cursor: "pointer",
                      }}
                    >
                      {Object.keys(checkboxStates).length > 0 && (
                        <Icon type="cross" size="12" />
                      )}
                    </button>
                  </div>
                  <BackButton
                    style={{ padding: "6px" }}
                    onClick={exportDataHandler}
                  >
                    <Icon type="export" />
                    <ButtonText>Export</ButtonText>
                  </BackButton>
                  <BackButton
                    style={{ padding: "6px" }}
                    onClick={printDataHandler}
                  >
                    <Icon type="print" />
                    <ButtonText>Print</ButtonText>
                  </BackButton>
                  {/* <BackButton
                    style={{ padding: "6px" }}
                    onClick={deleteMultipleDataHandler}
                  >
                    <Icon type="delete" />
                    <ButtonText>Delete</ButtonText>
                  </BackButton> */}
                </ExportDeleteBtnContainer>
              </div>
              <SearchBoxFilterContainer>
                <SearchParticipantsWrapper>
                  <Icon type="search" />
                  <TextInput
                    placeholder="Search for Participant"
                    value={searchParticipant}
                    setValue={setSearchParticipant}
                    isSearch={true}
                  />
                </SearchParticipantsWrapper>

                <FilterOption onClick={() => setFilterOptions(!filterOptions)}>
                  <Icon type="filter" />
                  <FilterText>Filter</FilterText>
                </FilterOption>
                {filterOptions && (
                  <FilterOptions ref={filterRef}>
                    <FilterHeadText>Filter By</FilterHeadText>
                    <FilterBy>
                      <FilterLabel>
                        <FilterLabelText>Requested by</FilterLabelText>
                        <FilterClear onClick={() => setRequestedBy("")}>
                          Clear
                        </FilterClear>
                      </FilterLabel>
                      <TextInput
                        maxWidth={"93%"}
                        isFilter={true}
                        placeholder="Search by name"
                        value={requestedBy}
                        setValue={setRequestedBy}
                      />
                    </FilterBy>
                    <FilterBy>
                      <FilterLabel>
                        <FilterLabelText>Accepted by</FilterLabelText>
                        <FilterClear onClick={() => setAcceptedBy("")}>
                          Clear
                        </FilterClear>
                      </FilterLabel>
                      <TextInput
                        maxWidth={"93%"}
                        isFilter={true}
                        placeholder="Search by name"
                        value={acceptedBy}
                        setValue={setAcceptedBy}
                      />
                    </FilterBy>
                    <FilterBy>
                      <FilterLabel>
                        <FilterLabelText>Date Range</FilterLabelText>
                        <FilterClear
                          onClick={() => setDateRange({ from: null, to: null })}
                        >
                          Clear
                        </FilterClear>
                      </FilterLabel>
                      <DateInputs>
                        <EnhancedDateRangePicker
                          dateRange={dateRange}
                          setDateRange={setDateRange}
                        />
                      </DateInputs>
                    </FilterBy>
                    <FilterButtons>
                      <ResetButton onClick={resetFilters}>
                        Reset All
                      </ResetButton>
                      <ApplyButton onClick={applyFilters}>
                        Apply Filter
                      </ApplyButton>
                    </FilterButtons>
                  </FilterOptions>
                )}
              </SearchBoxFilterContainer>
            </MeetingsHead>
            {loader ? (
              <Loading loadingItem="Meetings" />
            ) : filteredRequests.length === 0 ? (
              <NoprogramContainer>
                <RequestsKeyHeaders size={13} widthSize={300} marginSpace={30}>
                  <Link to={url}>
                    {" "}
                    {program?.title ? program?.title : "Program"}
                  </Link>
                  {"  "}
                  does not have any{" "}
                  {currentPage === "UPCOMING"
                    ? "New Bookings"
                    : currentPage === "COMPLETE"
                    ? "Completed Bookings"
                    : "Unaccepted Requests"}{" "}
                  .
                </RequestsKeyHeaders>
              </NoprogramContainer>
            ) : (
              <TableContainer>
                <PaginatedTable
                  meetingsDashboard={true}
                  setExportCurrentPageData={setExportCurrentPageData}
                  exportData={exportData}
                  meetings={true}
                  isActive={true}
                  selectAllHandler={selectAllHandler}
                  allChecked={allChecked}
                  columns={[
                    {
                      key: "name",
                      title: "Requested by",
                      checkbox: true,
                      sortable: true,
                      sortValueFn: (row) =>
                        `${row?.user?.firstName || ""} ${
                          row?.user?.lastName || ""
                        }`.toLowerCase(),
                      render: ({ row }) => {
                        return (
                          <RequestedByContainer>
                            <Checkbox
                              value={!!checkboxStates[row.id]}
                              setValue={(event) =>
                                handleCheckboxChange(row?.id, row)
                              }
                            />
                            <AvatarInfo>
                              <Info
                                width={"40px"}
                                squareSize={true}
                                nonWidth={true}
                              >
                                {
                                  <Avatar
                                    leftSpace={1}
                                    src={
                                      row?.user?.image
                                        ? row?.user?.image
                                        : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"
                                    }
                                  />
                                }
                              </Info>
                              <p>
                                {row?.user.firstName + " " + row?.user.lastName}
                              </p>
                            </AvatarInfo>
                          </RequestedByContainer>
                        );
                      },
                    },
                    {
                      key: "reasonForMeeting",
                      title: "Purpose",
                      sortable: true,
                      render: ({ row }) => {
                        return <Purpose>{row?.reasonForMeeting}</Purpose>;
                      },
                    },

                    {
                      key: "programJoinDate",
                      title: "Days Pending",
                      sortable: true,
                      sortValueFn: (row) => {
                        // Return a number representing days pending (similar logic as in your render)
                        if (
                          currentPage === "UPCOMING" ||
                          currentPage === "COMPLETE"
                        ) {
                          const days = row?.meetingScheduleDate
                            ? NumberOfDaysBetweenDates([
                                row?.acceptedOn,
                                dateToUnixTimeStamp(row?.createdAt),
                              ])
                            : NumberOfDaysBetweenDatesAndCurrentDate([
                                dateToUnixTimeStamp(row?.createdAt),
                              ]);
                          return days >= 0 ? days : null;
                        } else if (
                          currentPage === "PAST" &&
                          row.meetingScheduleDate === null
                        ) {
                          const dates = [row?.date, row?.date2, row?.date3];
                          dates.sort();
                          dates.reverse();
                          const days = NumberOfDaysBetweenDates([
                            dates[0],
                            dateToUnixTimeStamp(row?.createdAt),
                          ]);
                          return days >= 0 ? days : null;
                        }
                        return null;
                      },
                      render: ({ row }) => {
                        if (
                          currentPage === "UPCOMING" ||
                          currentPage === "COMPLETE"
                        ) {
                          const days = row?.meetingScheduleDate
                            ? NumberOfDaysBetweenDates([
                                row?.acceptedOn,
                                dateToUnixTimeStamp(row?.createdAt),
                              ])
                            : NumberOfDaysBetweenDatesAndCurrentDate([
                                dateToUnixTimeStamp(row?.createdAt),
                              ]);
                          if (days >= 0) {
                            return days;
                          }
                          return "-";
                        } else if (
                          currentPage === "PAST" &&
                          row.meetingScheduleDate === null
                        ) {
                          const dates = [row?.date, row?.date2, row?.date3];
                          dates.sort();
                          dates.reverse();
                          const days = NumberOfDaysBetweenDates([
                            dates[0],
                            dateToUnixTimeStamp(row?.createdAt),
                          ]);
                          if (days >= 0) {
                            return days;
                          }
                          return "-";
                        }
                        return "-";
                      },
                    },

                    {
                      key: "date",
                      title: `${
                        currentPage === "UPCOMING" || currentPage === "COMPLETE"
                          ? "Date"
                          : "Requested On"
                      }`,
                      sortValueFn: (row) => {
                        return new Date(row.createdAt).getTime() || 0;
                      },
                      sortable: true,
                      render: ({ row }) => {
                        return formatDateForMeetings(row.createdAt);
                      },
                    },

                    {
                      key: "status",
                      title: "Accepted by",
                      sortable: true,
                      sortValueFn: (row) => {
                        if (row.status === "ACCEPT") {
                          return row.Mentor?.firstName && row.Mentor?.lastName
                            ? row.Mentor.firstName + " " + row.Mentor.lastName
                            : null;
                        }
                        return null;
                      },
                      show:
                        currentPage === "UPCOMING" || currentPage === "COMPLETE"
                          ? true
                          : false,
                      render: ({ row }) => {
                        if (row.status === "ACCEPT") {
                          return row.Mentor?.firstName && row?.Mentor?.lastName
                            ? row.Mentor?.firstName +
                                " " +
                                row?.Mentor?.lastName
                            : "-";
                        } else {
                          return "-";
                        }

                        // return row.status[0] + row.status.slice(1).toLowerCase();
                      },
                    },
                    {
                      key: "",
                      title: "Actions",
                      sortable: true,
                      render: ({ row }) => {
                        return (
                          <TableActions isActive={true}>
                            <div
                              onMouseEnter={() => setActionButtons(row.id)}
                              onMouseLeave={() => setActionButtons(null)}
                            >
                              <DropIcon>
                                <Icon type="dropdown-dots" />
                              </DropIcon>
                              {actionButtons === row.id && (
                                <DropdownItems>
                                  <DropdownButton
                                    meetings={true}
                                    onClick={() => {
                                      setIsviewMore(row);
                                    }}
                                  >
                                    <Icon type={"view"} color="#302F2F" />
                                    View More
                                  </DropdownButton>
                                  <DropdownButton
                                    meetings={true}
                                    variant="secondary"
                                    onClick={() => {
                                      callAPI(
                                        dispatch,
                                        "initializeConversation",
                                        {
                                          id: row?.user?.id,
                                        }
                                      )
                                        .then((res) => {
                                          if (res) {
                                            navigate(
                                              `/messages/${row?.user?.uuid}`
                                            );
                                          }
                                        })
                                        .catch((error) => {
                                          console.error(error);
                                        });
                                    }}
                                  >
                                    <Icon type={"chat"} color="#302F2F" />
                                    Send Message
                                  </DropdownButton>

                                  <DropdownButton
                                    meetings={true}
                                    variant="secondary"
                                    onClick={() => setIsDeleteModal(row)}
                                  >
                                    <Icon type={"trash"} color="#302F2F" />
                                    Delete
                                  </DropdownButton>
                                </DropdownItems>
                              )}
                              {isDeleteModal && (
                                <Modal
                                  key={`deleteModal-${row.id}`}
                                  title={
                                    "Are you sure you want to delete this Meeting"
                                  }
                                  onClose={() => setIsDeleteModal(false)}
                                  setModalrespon={true}
                                >
                                  <SectionActions>
                                    <Button
                                      key={row}
                                      icon={
                                        isDeleteRequest ? "loading" : "trash"
                                      }
                                      variant="danger"
                                      onClick={() => {
                                        deleteProgram(isDeleteModal);
                                      }}
                                      text="Yes"
                                    />
                                    <ButtonSpacer />
                                    <Button
                                      icon="tick"
                                      variant="primary"
                                      onClick={() => setIsDeleteModal(false)}
                                      text="No"
                                    />
                                  </SectionActions>
                                </Modal>
                              )}
                            </div>
                          </TableActions>
                        );
                      },
                    },
                  ]}
                  rows={filteredRequests}
                />
              </TableContainer>
            )}
          </Labelize>
        </TableContainerOuter>
      </Body>

      {isViewMore && (
        <Modal
          title={"Meeting Information"}
          width={"90%"}
          fixedWidth={"600px"}
          isMeeting={true}
          isTask={true}
          onClose={closeModal}
          isButtonCenter
          actions={[
            {
              text: "Cancel",
              onClick: closeModal,
              textColor: true,
              isNotRound: "5px",
            },
          ]}
        >
          <MeetingInfo data={isViewMore} />
        </Modal>
      )}
    </ProgramContainer>
  );
}
export default ActivityContent;
